import { DiamondStoneIcon } from './DiamondStoneIcon';

/**
 * author: Simran
 * id 7AEA1B64-9B6D-4D55-91F8-05BA1BF3BF89
 * name diamond-stone
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diamond-stone.svg
 * tags
 */
export const JewelIcon = DiamondStoneIcon;
export default JewelIcon